import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PracticeWorkingHourList } from '@/types/scheduling-api';

/**
 * GET /api/Practice/WorkingHoursList/{practiceId}
 *
 * Returns the practice-wide working-hours profiles. The Day-view gutter
 * derives its hour range from this (filter type === 1 = work hours,
 * match each profile's `practiceWorkingSlots[].weedayId` to today).
 *
 * Mirrors Flutter's `FetchPracticeWorkingHoursListEvent`. Working hours
 * change rarely, so we cache for 5 minutes.
 */
export function usePracticeWorkingHours(practiceId: string | undefined) {
  return useQuery({
    queryKey: ['practice-working-hours', practiceId],
    queryFn: ({ signal }) => {
      if (!practiceId) throw new Error('practiceId required');
      return get<PracticeWorkingHourList[]>(
        `/api/Practice/WorkingHoursList/${practiceId}`,
        { signal },
      );
    },
    enabled: !!practiceId,
    staleTime: 5 * 60 * 1000,
  });
}
